import React from "react";
import DropdownButtonView from "presentational/common/DropdownButtonView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

PickAndBookmarkFolderDropdownButtonView.propTypes = {
  type: PropTypes.oneOf(["bookmarkFolder", "pickFolder"]).isRequired,
  folderList: PropTypes.array.isRequired,
  selectedItem: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disableRightMargin: PropTypes.bool
};

PickAndBookmarkFolderDropdownButtonView.defaultProps = {
  disableRightMargin: false
};

function PickAndBookmarkFolderDropdownButtonView(props) {
  const { type, folderList, selectedItem, onSelect, disableRightMargin } =
    props;

  return (
    <DropdownButtonView
      dropdownName={type}
      menuList={folderList}
      selectedItem={selectedItem}
      onSelect={onSelect}
      prefixText={<TXT name="btnSelect_folder" />}
      disableRightMargin={disableRightMargin}
    />
  );
}

export default PickAndBookmarkFolderDropdownButtonView;
